import { useCreatePath } from 'react-admin';
import { useRegisterBreadcrumb } from '../layout/navbar/BreadcrumbsManager';
import resourceNames from '../../constants/resourceNames';

const ApiKeyListBreadcrumb = () => {
  const createPath = useCreatePath();
  const path = createPath({ resource: resourceNames.API_KEYS, type: 'list' });
  useRegisterBreadcrumb({
    title: 'API Keys',
    path,
  });

  return null;
};

export default ApiKeyListBreadcrumb;
